import * as React from 'react';
import { SlideUpPanel } from 'mobile-ui/components/slideup-panel';
import {
    PanelHeader,
    CloseButton,
    PanelBody
} from 'components';
import { ObjectsList } from 'scenes/list-window/objects-list';
import { ListFilters } from 'scenes/list-window/filters';
import { routes } from 'routes';
import { IState } from 'services/root-reducer';
import { getContainerFilters, getObjectsListData } from 'selectors';
import { connect } from 'react-redux';
import { actions as appActions } from 'services/app/app-service';
import { actions as containersActions } from 'services/containers/containers-service';
import './style.scss';
import { CSSTransition } from 'react-transition-group';
import clsx from 'clsx';
import { IOperation } from 'types';
import i18next from 'i18next';


export interface IMobileUIListWindowProps {
    layerCode: string;
    filters: any;
    listOperationData: any;
}
export interface IMobileUIListWindowState {
    is_layer_filters_opened: boolean;
}

const mapStateToProps = (state: IState, props) => ({
    filters: getContainerFilters(state, props.layerCode),
    listOperationData: getObjectsListData(state, props.layerCode)
});

class MobileUIListWindowComponent extends React.Component<IMobileUIListWindowProps, IMobileUIListWindowState> {
    constructor(props: IMobileUIListWindowProps) {
        super(props);

        this.state = this.getInitialState();
    }

    getInitialState(): IMobileUIListWindowState {
        return {
            is_layer_filters_opened: false
        };
    }

    componentDidMount() {
        if (i18next.language !== 'ru'
            && [ 'folder88', 'folder12', 'productive_agricultural_land' ].includes(this.props.layerCode)) {
            routes.goBack(routes.map, { container: 'root' }, routes.currRouteState);
            containersActions.setContainerSelected({ id_or_code: 'folder88', selected: false });
            containersActions.setContainerSelected({ id_or_code: 'folder12', selected: false });
            containersActions.setContainerSelected({ id_or_code: 'productive_agricultural_land', selected: false });
        }
    }

    render() {
        let { filters, layerCode } = this.props;
        let is_plots_layer = layerCode === 'plots';
        let layer_has_filters = (filters.length > 0 && !is_plots_layer);

        return (
            <SlideUpPanel
                open
                className='mobile-ui-objects-list fix-close-button'
            >
                <PanelHeader>
                    <div className="mobile-ui-objects-list__header-name">
                        {this.props.listOperationData.containerName}
                    </div>
                    {/*
                    <LinkButton
                        className={clsx('back-button', {
                            'no-back': !this.state.is_layer_filters_opened
                        })}
                        icon={<Icons.IconArrowLeft />}
                        onClick={() => {
                            this.setState({
                                is_layer_filters_opened: false
                            });
                        }}
                    />
                    */}
                    <CloseButton
                        onClick={() => {
                            if (this.state.is_layer_filters_opened) {
                                this.setState({
                                    is_layer_filters_opened: false
                                });
                            } else {
                                // routes.goBack(routes.map, { container: 'root' });
                                routes.redirect(routes.map, { container: 'root' });
                            }
                        }}
                    />
                </PanelHeader>

                <PanelBody>
                    <CSSTransition
                        in={this.state.is_layer_filters_opened}
                        classNames="animation-state"
                        timeout={200}
                    >
                        <ObjectsList
                            smallFilterButton
                            className='slide-right-animation'
                            layerCode={this.props.layerCode}
                            onFilterClick={
                                (layer_has_filters || is_plots_layer)
                                    ? () => {
                                        if (is_plots_layer) {
                                            appActions.showObjectFiltersWindow();
                                        } else {
                                            appActions.hideObjectFiltersWindow();
                                            this.setState({
                                                is_layer_filters_opened: true
                                            });
                                        }
                                    }
                                    : false
                            }
                        />
                    </CSSTransition>

                    <CSSTransition
                        in={this.state.is_layer_filters_opened}
                        classNames="animation-state"
                        timeout={200}
                    >
                        <div className='mobile-ui-list-filters-wrapper slide-left-animation'>
                            <ListFilters
                                containerCode={layerCode}
                                contFilters={filters}
                            />
                        </div>
                    </CSSTransition>
                </PanelBody>
            </SlideUpPanel>
        );
    }
}

export const MobileUIListWindow = connect(mapStateToProps)(MobileUIListWindowComponent);
